/**
 * Helper function for fetching and caching with sessionStorage.
 *
 * @param {String} key id for session storage
 * @param {Array} fetchProps values passes to fetch function
 * @param {Boolean} bypassSessionStorageCache Whether to ignore cache
 *
 * @returns {Promise<unknown>} The Request Promise
 */
const getCachedRequest = (key, fetchProps, bypassSessionStorageCache = false) =>
  new Promise((resolve, reject) => {
    // check cache
    if (window.sessionStorage.getItem(key) && !bypassSessionStorageCache) {
      const cache = JSON.parse(window.sessionStorage.getItem(key))
      // use if not expired
      if (cache.expire === null || cache.expire > Date.now()) {
        resolve(cache[key])
        return // don't continue
      }
    }
    // make requests
    fetch(...fetchProps)
      .then(async res => {
        const json = await res.json()
        return { success: res.status === 200, json }
      })
      .then(({ success, json }) => {
        if (success) {
          const cache = {
            [key]: json,
            expire: Date.now() + 300 * 1000,
          }
          window.sessionStorage.setItem(key, JSON.stringify(cache))
          resolve(json)
        } else {
          reject(json)
        }
      })
      .catch(err => {
        reject(err)
      })
  })

export default getCachedRequest
